module.exports = __webpack_public_path__ + "img/android.66372a83.png";